import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import i from "../core/ArrayPool.js";
import s from "../core/Handles.js";
import { init as a } from "../core/watchUtils.js";
import { property as t } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as r } from "../core/accessorSupport/decorators/subclass.js";
var l = {
  widthBreakpoint: {
    getValue: function getValue(e) {
      var i = e.viewSize[0],
          s = e.breakpoints,
          a = this.values;
      return i <= s.xsmall ? a.xsmall : i <= s.small ? a.small : i <= s.medium ? a.medium : i <= s.large ? a.large : a.xlarge;
    },
    values: {
      xsmall: "xsmall",
      small: "small",
      medium: "medium",
      large: "large",
      xlarge: "xlarge"
    },
    valueToClassName: {
      xsmall: "esri-view-width-xsmall esri-view-width-less-than-small esri-view-width-less-than-medium esri-view-width-less-than-large esri-view-width-less-than-xlarge",
      small: "esri-view-width-small esri-view-width-greater-than-xsmall esri-view-width-less-than-medium esri-view-width-less-than-large esri-view-width-less-than-xlarge",
      medium: "esri-view-width-medium esri-view-width-greater-than-xsmall esri-view-width-greater-than-small esri-view-width-less-than-large esri-view-width-less-than-xlarge",
      large: "esri-view-width-large esri-view-width-greater-than-xsmall esri-view-width-greater-than-small esri-view-width-greater-than-medium esri-view-width-less-than-xlarge",
      xlarge: "esri-view-width-xlarge esri-view-width-greater-than-xsmall esri-view-width-greater-than-small esri-view-width-greater-than-medium esri-view-width-greater-than-large"
    }
  },
  heightBreakpoint: {
    getValue: function getValue(e) {
      var i = e.viewSize[1],
          s = e.breakpoints,
          a = this.values;
      return i <= s.xsmall ? a.xsmall : i <= s.small ? a.small : i <= s.medium ? a.medium : i <= s.large ? a.large : a.xlarge;
    },
    values: {
      xsmall: "xsmall",
      small: "small",
      medium: "medium",
      large: "large",
      xlarge: "xlarge"
    },
    valueToClassName: {
      xsmall: "esri-view-height-xsmall esri-view-height-less-than-small esri-view-height-less-than-medium esri-view-height-less-than-large esri-view-height-less-than-xlarge",
      small: "esri-view-height-small esri-view-height-greater-than-xsmall esri-view-height-less-than-medium esri-view-height-less-than-large esri-view-height-less-than-xlarge",
      medium: "esri-view-height-medium esri-view-height-greater-than-xsmall esri-view-height-greater-than-small esri-view-height-less-than-large esri-view-height-less-than-xlarge",
      large: "esri-view-height-large esri-view-height-greater-than-xsmall esri-view-height-greater-than-small esri-view-height-greater-than-medium esri-view-height-less-than-xlarge",
      xlarge: "esri-view-height-xlarge esri-view-height-greater-than-xsmall esri-view-height-greater-than-small esri-view-height-greater-than-medium esri-view-height-greater-than-large"
    }
  },
  orientation: {
    getValue: function getValue(e) {
      var i = e.viewSize,
          s = i[0],
          a = i[1],
          t = this.values;
      return a >= s ? t.portrait : t.landscape;
    },
    values: {
      portrait: "portrait",
      landscape: "landscape"
    },
    valueToClassName: {
      portrait: "esri-view-orientation-portrait",
      landscape: "esri-view-orientation-landscape"
    }
  }
},
    h = {
  xsmall: 544,
  small: 768,
  medium: 992,
  large: 1200
};

function n(e) {
  var i = e;
  return i && i.xsmall < i.small && i.small < i.medium && i.medium < i.large;
}

function o(e, i) {
  return i ? l[e].valueToClassName[i].split(" ") : [];
}

var m = function m(_m2) {
  var g = /*#__PURE__*/function (_m) {
    _inherits(g, _m);

    var _super = _createSuper(g);

    function g() {
      var _this;

      _classCallCheck(this, g);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(e)), _this._breakpointsHandles = new s(), _this.orientation = null, _this.widthBreakpoint = null, _this.heightBreakpoint = null, _this.breakpoints = h;
      return _this;
    }

    _createClass(g, [{
      key: "initialize",
      value: function initialize() {
        this._breakpointsHandles.add(a(this, ["breakpoints", "size"], this._updateClassNames));
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.destroyed || (this._removeActiveClassNames(), this._breakpointsHandles.destroy(), this._breakpointsHandles = null);
      }
    }, {
      key: "breakpoints",
      set: function set(e) {
        if (e === this._get("breakpoints")) return;
        var i = n(e);

        if (!i) {
          var _e = JSON.stringify(h, null, 2);

          console.warn("provided breakpoints are not valid, using defaults:" + _e);
        }

        e = i ? e : h, this._set("breakpoints", _objectSpread({}, e));
      }
    }, {
      key: "_updateClassNames",
      value: function _updateClassNames() {
        if (!this.container) return;
        var e = i.acquire(),
            s = i.acquire();
        var a,
            t = !1;

        for (a in l) {
          var _i = this[a],
              _r = l[a].getValue({
            viewSize: this.size,
            breakpoints: this.breakpoints
          });

          _i !== _r && (t = !0, this[a] = _r, o(a, _i).forEach(function (e) {
            return s.push(e);
          }), o(a, _r).forEach(function (i) {
            return e.push(i);
          }));
        }

        t && (this._applyClassNameChanges(e, s), i.release(e), i.release(s));
      }
    }, {
      key: "_applyClassNameChanges",
      value: function _applyClassNameChanges(e, i) {
        var s = this.container;
        s && (i.forEach(function (e) {
          return s.classList.remove(e);
        }), e.forEach(function (e) {
          return s.classList.add(e);
        }));
      }
    }, {
      key: "_removeActiveClassNames",
      value: function _removeActiveClassNames() {
        var e = this.container;
        if (!e) return;
        var i;

        for (i in l) {
          o(i, this[i]).forEach(function (i) {
            return e.classList.remove(i);
          });
        }
      }
    }]);

    return g;
  }(_m2);

  return e([t()], g.prototype, "breakpoints", null), e([t()], g.prototype, "orientation", void 0), e([t()], g.prototype, "widthBreakpoint", void 0), e([t()], g.prototype, "heightBreakpoint", void 0), g = e([r("esri.views.BreakpointsOwner")], g), g;
};

export { m as BreakpointsOwner };